import { IActionData } from 'models/common';

export interface IDiscountStrategyAction {
	type: string;
	payload: Partial<IGroupedDiscountStrategy>;
}

export enum DiscountStrategyType {
	LimitedTimeOffer = 0,
	PromoCode = 1,
}

export interface IDiscountStrategy {
	id?: string;
	shopId: string;
	title?: string;
	promoCode?: string;
	validFrom?: string;
	validTo?: string;
	minimumAmount?: number;
	isDiscountPercentage?: boolean;
	discountValue: number;
	reusable?: boolean;
	applied?: boolean;
	appliedOn?: string;
	isActive?: boolean;
	productId?: string;
	type: DiscountStrategyType;
	addedDate?: string;
	categories?: string;
	bookingTemplateId?: string;
	officeId?: string;
	description?: string;
	groupId?: string;
	isSellingPrice?: boolean; // if true then isDiscountPercentage cannot be true
}

export interface IGroupedDiscountStrategy extends IActionData {
	shopId?: string;
	groupedDiscountStrategies: { [key: string]: IDiscountStrategy[] };
}
